module.exports = __webpack_public_path__ + "static/media/Banner-beneficios.7ba1d444.gif";